"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SimpleModal;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _merchButton = require("@site/pattern-library-core/merch-button");
var _modal = _interopRequireDefault(require("@ux/modal"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * SimpleModal Component - A basic modal inside core component library
 * @module SimpleModal
 *
 * @param {Object} props React props
 * @param {Object} props.cta CTA object for the trigger button
 * @param {string} props.modalCloseAriaLabel Aria label for close button
 * @param {React.ReactNode} props.children Content to display in the modal
 * @param {string} props.modalId Unique ID for the modal
 * @returns {React.ReactElement} SimpleModal component
 * @public
 */
function SimpleModal({
  cta: modalCTA,
  planbox,
  modalCloseAriaLabel = 'Close modal',
  modalRetryText = 'Retry',
  children,
  modalId = 'simple-modal'
}) {
  const [showModal, setShowModal] = (0, _react.useState)(false);
  const handleClick = () => {
    setShowModal(true);
  };
  const handleClose = () => {
    setShowModal(false);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_merchButton.NSMerchButtonSet, {
    buttons: [{
      isPromo: false,
      onClick: handleClick,
      href: '#',
      ...modalCTA,
      ['data-cy']: 'modal-trigger',
      dataCy: 'modal-trigger'
    }]
  }), showModal && /*#__PURE__*/_react.default.createElement(_modal.default, {
    id: planbox?.id ? `planbox-modal-${planbox.id}` : modalId,
    onClose: handleClose,
    "aria-label": modalCloseAriaLabel,
    "data-cy": "simple-modal"
  }, children, modalRetryText && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginTop: '1rem',
      textAlign: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement("button", {
    onClick: handleClose,
    style: {
      padding: '0.5rem 1rem',
      backgroundColor: '#0073e6',
      color: 'white',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer'
    }
  }, modalRetryText))));
}
SimpleModal.propTypes = {
  cta: _propTypes.default.object.isRequired,
  planbox: _propTypes.default.object,
  modalCloseAriaLabel: _propTypes.default.string,
  modalRetryText: _propTypes.default.string,
  children: _propTypes.default.node,
  modalId: _propTypes.default.string
};